export default __webpack_public_path__ + "static/media/XS4 Mini Locker.c09d6591.jpg";